/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports.ThemeProvider = void 0;

var react_1 = __importDefault(require("react"));

var name = 'ThemeProvider';
exports.name = name;

var ThemeProvider = /*#__PURE__*/function (_react_1$default$Pure) {
  _inherits(ThemeProvider, _react_1$default$Pure);

  var _super = _createSuper(ThemeProvider);

  function ThemeProvider(props) {
    _classCallCheck(this, ThemeProvider);

    return _super.call(this, props);
  }

  _createClass(ThemeProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          containerClass = _this$props.containerClass,
          css = _this$props.css,
          theme = _this$props.theme;
      return react_1.default.createElement(react_1.default.Fragment, null, css && react_1.default.createElement("style", null, css), react_1.default.createElement("div", {
        className: containerClass
      }, children));
    }
  }]);

  return ThemeProvider;
}(react_1.default.PureComponent);

exports.ThemeProvider = ThemeProvider;